import { render, staticRenderFns } from "./CDC-Split.vue?vue&type=template&id=60d28daa&scoped=true"
import script from "./CDC-Split.vue?vue&type=script&lang=js"
export * from "./CDC-Split.vue?vue&type=script&lang=js"
import style0 from "./CDC-Split.vue?vue&type=style&index=0&id=60d28daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d28daa",
  null
  
)

export default component.exports